import "./GradientBar.less";

import { Button, Icon, Input } from "antd";
import * as React from "react";
import Highlighter from "react-highlight-words";

import { AuthorizedComponent } from "components/general";
import { IBaseProps, IHighlightProps } from "lib/data/interfaces";
import { RedirectButton } from "../RedirectButton";

interface IGradientBarProps extends IBaseProps, IHighlightProps {
	contentClassName?: string;
	childrenClassName?: string;
	title?: string;
	titleAppendage?: React.ReactNode;
	superTitle?: string | React.ReactElement;
	subTitle?: string | React.ReactElement;
	actions?: Array<React.ReactElement<Button | AuthorizedComponent<Button>>>;
	size?: "small" | "medium" | "large";
	isEditing?: boolean;
	href?: string;
	onClick?: () => void;
	onNameChange?: (newName: string) => void;
}

export class GradientBar extends React.Component<IGradientBarProps, any> {

	public newName: string = "";

	public constructor(props: IGradientBarProps) {

		super(props);
	}

	public render() {

		const clickableClass = this.props.onClick !== undefined || this.props.href !== undefined ? "clickable-bar" : undefined;

		// Define Class Name(s)
		const className = [
			"bar",
			clickableClass,
			`${(this.props.size ? this.props.size : "medium")}-bar`,
			this.props.className
		].filter((v) => v !== undefined && v !== null).join(" ");

		// Define Content Class Name(s)
		const contentClassName = [
			"bar-content",
			clickableClass,
			`${(this.props.size ? this.props.size : "medium")}-bar`,
			this.props.contentClassName
		].filter((v) => v !== undefined && v !== null).join(" ");

		// Define Children Class Name(s)
		const childrenClassName = [
			"bar-body",
			`${(this.props.size ? this.props.size : "medium")}-bar`,
			this.props.childrenClassName
		].filter((v) => v !== undefined && v !== null).join(" ");


		let titleBar: React.ReactNode;

		// Check For Editing
		if (this.props.isEditing) {

			titleBar = (
				<div className="bar-title-wrapper">
					<div className="bar-title">
						<Input
							className="bar-title-input"
							placeholder={this.props.title ? this.props.title : "Enter a name"}
							onChange={this.handleNameInput}
							defaultValue={this.props.title}
						/>
					</div>
				</div>
			);
		}
		else {
			titleBar = (
				<React.Fragment>
					<div className="bar-title-wrapper">

						{(this.props.superTitle
							?
							(
								<div className="bar-super-title">

									{this.props.superTitle}

								</div>
							)
							:
							undefined
						)}

						<div className="bar-title">

							{(this.props.title
								?
								(
									<React.Fragment>
										{(this.props.highlightWords !== undefined
											?
											<Highlighter searchWords={[this.props.highlightWords.join(" ")]} textToHighlight={this.props.title} />
											:
											this.props.title
										)}
										{(this.props.titleAppendage !== undefined
											?
											this.props.titleAppendage
											:
											null
										)}
									</React.Fragment>
								)
								:
								undefined
							)}

						</div>

						{(this.props.subTitle
							?
							(
								<div className="bar-sub-title">

									{this.props.subTitle}

								</div>
							)
							:
							undefined
						)}

					</div>
					{
						this.props.onClick !== undefined || this.props.href !== undefined
							?
							(
								<div className="bar-navigate-icon-container">
									<Icon type="caret-right" />
								</div>
							)
							:
							null
					}
				</React.Fragment>
			);
		}

		// Render Normally
		return (

			<div className={className}>

				<div className="indicator border-right-unrounded" />

				<div className={contentClassName}>

					<div className="bar-header">

						{(this.props.onClick !== undefined
							?
							(
								<Button
									className="bar-title-wrapper-button"
									type="ghost"
									onClick={this.props.onClick}
								>
									{titleBar}
								</Button>
							)
							:
							(this.props.href !== undefined
								?
								(
									<RedirectButton
										className="bar-title-wrapper-button"
										type="ghost"
										href={this.props.href}
									>
										{titleBar}
									</RedirectButton>
								)
								:
								titleBar
							)
						)}

						{
							this.props.actions !== undefined
								?
								(
									<div className="bar-actions">

										<Button.Group className="actions_button_group">
											{this.props.actions.map((actionButton, index) => React.cloneElement(actionButton, { key: index }))}
										</Button.Group>

									</div>
								)
								:
								null
						}

					</div>

					<div className={childrenClassName}>

						{this.props.children}

					</div>
				</div>
			</div>
		);
	}

	private handleNameInput = async (event: any) => {

		const { value } = event.target;
		this.newName = value;

		if (this.props.onNameChange) {

			this.props.onNameChange(this.newName);
		}
	}
}
